/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_onboarding_step_connect_title = /** @type {(inputs: {}) => string} */ () => {
	return `Conecta tu agente de IA a Bloque`
};

const en_onboarding_step_connect_title = /** @type {(inputs: {}) => string} */ () => {
	return `Connect your AI agent to Bloque`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const onboarding_step_connect_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.onboarding_step_connect_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("onboarding_step_connect_title", locale)
	if (locale === "es") return es_onboarding_step_connect_title(inputs)
	return en_onboarding_step_connect_title(inputs)
};
export { onboarding_step_connect_title as "onboarding.step_connect.title" }